import * as React from 'react'

import { ChildListenerContext, TChildListener } from './context'

export const ChildListenerProvider = ({ children, ...props }) => {
  const [childListener, setChildListener] = React.useState<TChildListener>(null)

  return (
    <ChildListenerContext.Provider
      value={{
        childListener,
        setChildListener
      }}
    >
      {React.Children.map(children, child =>
        React.cloneElement(child, {
          ...props
        })
      )}
    </ChildListenerContext.Provider>
  )
}



// WEBPACK FOOTER //
// ./src/components/ChildListener/ChildListenerProvider.tsx